<template>
  <div  class="m-pc-bg-drck top-nav m-pc-metting-schedule " v-if="extras && extras.previous.display === 1" id="previous">
    <Title :key="2"
      v-if="extras.previousTitle.display == 1"
      :title="extras.previousTitle.model"
    />
    <div class="pc-metting-content u-w1200">
      <div class="previous" v-if="list.length">
        <swiper :options="swiperOptions">
          <swiper-slide
            v-for="(item, index) in list"
            :key="index"
            class="swiper-slide"
          >
            <div class="g-info-top" style="height: 100%" @click="go(item)">
              <img :src="item.coverImageRealPath" />
            </div>
          </swiper-slide>
        </swiper>

        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/index/Title.vue";
import { URLS } from "fire-wind-water";

export default {
  components: {
    Title,
  },
  props: {
    previousInfo: Object,
    extras: Object,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "auto",
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        loop: false,
      },
      title: "主办方介绍",
      list: [],
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    console.log("previousInfo", this.previousInfo);
    this.list = this.previousInfo.article;
    //    this.$forceUpdate();
  },
  methods: {
    go(item){
      if(item.linkUrl){
        if (
          item.linkUrl != "" &&
          item.linkUrl != "https://" &&
          item.linkUrl != "http://"
        ) {
          window.open(item.linkUrl);
        }

      }
    }
  },
};
</script>
<style scoped></style>
